module.exports = __webpack_public_path__ + "24a3f1e921e7a0b138efb04273e859b6.pdf";